import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, TextField as MuiTextField,Box } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {  dropdownFetch, formatDate,  getKeyPathValue, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';



const TABLE_HEADER = [
  {
    header: "Patient Name",
    accessor: "patient_name"
  },
  {
    header:"UHID",
    accessor :"uhid"
  },
  {
    header: 'Ipd No.',
    accessor: 'ipd_no'
  },
  {
    header: 'Transfer Date',
    accessor: (row)=> `${formatDate(row?.date)} ${row?.time}`
  },
  {
    header: 'Status',
    accessor: "status",
    sx: { textTransform: "uppercase" }

  }
]

const ROOM_TRANSFER_HEADER = [
  {
    header: 'Patient Name',
    accessor: (row) => row?.patient?.name
  },
  {
    header: 'Ipd No.',
    accessor: 'ipd_no'
  },
  {
    header: 'UHID No.',
    accessor: 'uhid'
  }
];

const TRANSFER_HISTORY_HEADER = [
  {
    header: 'Transfer Date ',
    accessor: (row) => formatDate(row?.date)
  },
  {
    header: 'Time',
    accessor: 'time'
  },
  {
    header: 'Old Ward',
    accessor: (row) => row?.ward?.name
  },
  {
    header: 'Old Room',
    accessor: (row) => row?.room?.room_no
  },
  {
    header: 'Old Bed No.',
    accessor: 'bed_no'
  },
  {
    header: 'New Ward',
    accessor: (row) => row?.transfer_ward?.name
  },
  {
    header: 'New Room',
    accessor: (row) => row?.transfer_room?.room_no
  },

  {
    header: 'New Bed No.',
    accessor: 'transfer_bed_no'
  }
];

const initialRoomTransferDataObj = {
  data: [],
  loading: false
};

const initialPatientDataObj = {
  data: [],
  loading: false
};



export const RoomTransfer = () => {
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [roomTransferDataObj, setRoomTransferDataObj] = useState(initialRoomTransferDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [patientData, setPatientData] = useState(initialPatientDataObj);
  const [departmentDropdown, setDepartmentDropdown] = useState([])
  const [departmentUnitDropdown, setDepartmentUnitDropdown] = useState([])
  const [nursingStationDropdown, setNursingStationDropdown] = useState([])
  const [wardDropdown, setWardDropdown] = useState([])
  const [roomDropdown, setRoomDropdown] = useState([])
  const [roomTransfer, setRoomTransfer] = useState([])
  const [input, setInput] = useState('');
  const [roomInput,setRoomInput] = useState('')
  const [originalData, setOriginalData] = useState([]);
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation  = pathParts[1]; 
  const user = JSON.parse(localStorage.getItem('user'));
  console.log("HELLLO USERS", user)
  const isEnabledDate = user && user.permissions ? user.permissions.some(permission =>
    permission.includes("DatePermission")
  ) : false;

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        uhid: Yup.string().required(' '),
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),

    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, '', ['_id', 'dob', 'status', '__v']);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      const formattedRegDate = selectedRecord?.date
        ? new Date(selectedRecord.date).toISOString().split('T')[0]
        : '';
      setValue('date', formattedRegDate)
      setValue('time', selectedRecord?.time)
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/room-transfer-update' : '/room-transfer-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {...formValues,    
        createdBy: user.name,
        updatedBy: editFlag? user.name: '',
        organisation
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} `, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} `, { variant: 'error' });
    }
    setLoading(false);
  };

  const fetchIpdPatient = async () => {
    setPatientData({ loading: true, data: [] });
    try {
      const response = await request('/indoor-registeration-list-admit-patient', { method: 'GET' });
      if (response.success) {
        const filteredData = response.data
          .filter(item => item.admission_status === 'admit')
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        setPatientData({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setPatientData({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error fetching patient data:', error);
      toast('Error in fetching data', { variant: 'error' });
      setPatientData({ loading: false, data: [] });
    }
  };


  const fetchRoomTransferPatient = async () => {
    setPatientData({ loading: true, data: [] });
    try {
      const response = await request('/room-transfer-list', { method: 'GET' });
      if (response.success) {
        const filteredData = response.data.filter(
          (item) => item.ipd_no === selectedRecord?.ipd_no
        );
        const sortedData = filteredData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setRoomTransfer({ loading: false, data: sortedData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setRoomTransfer({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error fetching Room Transfer Data', error);
      toast('Error in fetching data', { variant: 'error' });
      setRoomTransfer({ loading: false, data: [] });
    }
  };

  useEffect(() => {
    fetchIpdPatient();
    fetchRoomTransferPatient()
  }, []);


  const handleRowClick = (row) => {
    setValue('ipd_no', row?.ipd_no)
    setValue('uhid', row?.uhid)
    setValue('department', row?.consultant_detail?.department?._id)
    setValue('room', row?.consultant_detail?.room?._id)
    setValue('bed_no', row?.consultant_detail?.bed_no)
    setValue('ward', row?.consultant_detail?.room?.ward?._id)
    setValue('unit', row?.consultant_detail?.room?.department_unit?._id)
    setValue('nur_station', row?.consultant_detail?.room?.nurse_station?._id)
    setValue('pre_room', calculateDaysFromToday(row?.date))
    setValue('adm_date', formatDate(row?.date))
    setValue('patient_name', row.patient?.name)
    setValue('transfer_department', row?.consultant_detail?.department?._id)
    setValue('transfer_unit', row?.consultant_detail?.room?.department_unit?._id)
    setValue('transfer_nursing_station', row?.consultant_detail?.room?.nurse_station?._id)
    setValue('transfer_ward', row?.consultant_detail?.room?.ward?._id)
    setValue('transfer_room', row?.consultant_detail?.room?._id)
  }

  const calculateDaysFromToday = (dateString) => {
    const givenDate = new Date(dateString);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const timeDifference = today - givenDate;
    const dayDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    return dayDifference;
  }


  const getDepartmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('department');
    setDepartmentDropdown(data);
  }, []);

  const getDepartmentUnitDropdown = useCallback(async () => {
    const data = await dropdownFetch('department-unit');
    setDepartmentUnitDropdown(data);
  }, []);

  const getNursingStationDropdown = useCallback(async () => {
    const data = await dropdownFetch('nursing-station');
    setNursingStationDropdown(data);
  }, []);

  const getWardDropdown = useCallback(async () => {
    const data = await dropdownFetch('ward');
    setWardDropdown(data);
  }, []);


  const getRoomDropdown = useCallback(async () => {
    const data = await dropdownFetch('room-master');
    setRoomDropdown(data);
  }, []);


  useEffect(() => {
    getDepartmentDropdown()
    getDepartmentUnitDropdown()
    getNursingStationDropdown()
    getWardDropdown()
    getRoomDropdown()

  }, getDepartmentDropdown, getDepartmentUnitDropdown, getNursingStationDropdown, getWardDropdown, getRoomDropdown)


  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setRoomTransferDataObj({ loading: true });
    try {
      const response = await request('/room-transfer-list', { method: 'GET' });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.date) - new Date(a.date));
        const filteredData = sortedData.filter(item =>
          item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setRoomTransferDataObj({ loading: false, data: filteredData });
        setOriginalData(filteredData)

      } else {
        toast('Error in fetching data', { variant: 'error' });
        setRoomTransferDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching patient data:', error);
      toast('Error in fetching data', { variant: 'error' });
      setRoomTransferDataObj({ loading: false });
    }
  };


  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/room-transfer-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled Room Transfer', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Cancelled  Room Transfer', { variant: 'error' });
    }
    setLoading(false);
  };


  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/room-tranfer-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Room Transfer', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Room Transfer', { variant: 'error' });
    }
    setLoading(false);
  };



  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  useEffect(()=>{
    handleUhidSearch()
  },[input])

  const handleUhidSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    try {
      const query = {};
      if (lowercasedInput) {
        query.name = lowercasedInput;
      }
      const response = await request('/indoor-registeration-list-admit-patient', {
        method: 'GET',
        query: query
      });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setPatientData({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setPatientData({ loading: false });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setPatientData({ loading: false, data: [] });
    }
  };

const handleRoomChange = (e) => {
  setRoomInput(e.target.value);
};

const handleRoomTransferSearch = async () => {
  setRoomTransferDataObj({ loading: true });
  const lowercasedInput = roomInput.toLowerCase().trim();
   const query = {};
  if (lowercasedInput) {
    query.name = lowercasedInput;
  }
  try {
    const response = await request('/room-transfer-list', { method: 'GET',query: query});
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.date) - new Date(a.date));
      const filteredData = sortedData.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setRoomTransferDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setRoomTransferDataObj({ loading: false });
    }
  } catch (error) {
    console.error('Error fetching patient data:', error);
    toast('Error in fetching data', { variant: 'error' });
    setRoomTransferDataObj({ loading: false });
  }
};

useEffect(()=>{
  handleRoomTransferSearch();
},[roomInput])

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" fontWeight={700}>
                Room Transfer Management
              </Typography>

              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                  }}
                >
                  New
                </Button>
                <Button
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </Button>
                <Button
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </Button>
                <Button
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                  onClick={handleQueryWindow}
                >
                  Query
                </Button>
                <Button variant="contained" disabled={!selectedRecord || currentAction}>
                  Print
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </Button>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '1px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', boxShadow: '0px 4px 4px #0099ff' }}>
                  <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
                    <MuiTextField
                      sx={{
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                          padding: '0',
                          fontSize: '1.4rem' // Adjust input font size
                        },
                        '& .MuiOutlinedInput-input': {
                          padding: '8px 1.4rem'
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: '1.2rem' // Adjust label font size
                        }
                      }}
                      label="Search Patient"
                      variant="outlined"
                      value={input}
                      onChange={handleChange}
                    />
                  </Stack>
                  <Table
                    containerSX={{ flex: 1 }}
                    data={currentAction === 'new' ? patientData?.data : []}
                    columns={ROOM_TRANSFER_HEADER}
                    size="small"
                    onRowClick={handleRowClick}
                  />
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{ display: 'flex', gap: 0.3, flexDirection: 'column', boxShadow: '0px 4px 4px #0099ff' }}
                >
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                    <TextField sx={{ flex: 0.8 }} placeholder="Patient Name" name="patient_name" disabled />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Adm. No.</Typography>
                    <TextField sx={{ flex: 0.8 }} name="ipd_no" disabled />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>UHID No.</Typography>
                    <TextField sx={{ flex: 0.8 }} placeholder="Uhid" name="uhid" disabled />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Department</Typography>
                    <SelectTag
                      menus={departmentDropdown.map((data) => ({ ...data, name: data.department }))}
                      formControlSX={{ flex: 0.8, fontWeight: 700, fontSize: '1.4rem' }}
                      placeholder="Department"
                      name="department"
                      disabled
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Unit</Typography>
                    <SelectTag
                      menus={departmentUnitDropdown.map((data) => ({ ...data, name: data.name }))}
                      formControlSX={{ flex: 0.8 }}
                      placeholder="Unit"
                      name="unit"
                      disabled
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Nursing Station</Typography>
                    <SelectTag
                      menus={nursingStationDropdown}
                      formControlSX={{ flex: 0.8 }}
                      name="nur_station"
                      placeholder="Nursing Station"
                      disabled
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Ward</Typography>
                    <SelectTag
                      menus={wardDropdown}
                      formControlSX={{ flex: 0.8 }}
                      name="ward"
                      placeholder="ward"
                      disabled
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Room</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="room"
                      placeholder="room"
                      menus={roomDropdown
                        .filter(
                          (data) =>
                            data.nurse_station === watch('nur_station') &&
                            data.ward === watch('ward') &&
                            data.department_unit === watch('unit')
                        )
                        .map((data) => ({ ...data, name: data.room_no }))}
                      onChange={() => {
                        setValue('bed_no', '');
                      }}
                      disabled
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Bed No.</Typography>
                    <TextField sx={{ flex: 0.8 }} name="bed_no" placeholder="Bed No." disabled />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.7, fontWeight: 700, fontSize: '1.4rem' }}>
                      Days Stay In Pre. Room
                    </Typography>
                    <TextField sx={{ flex: 0.4 }} name="pre_room" placeholder="" disabled />
                    <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Date</Typography>
                    <TextField sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }} name="adm_date" disabled />
                  </Stack>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{ display: 'flex', gap: 0.3, flexDirection: 'column', boxShadow: '0px 4px 4px #0099ff' }}
                >
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Date/Time</Typography>
                    <TextField
                      name="date"
                      sx={{ flex: 0.4 }}
                      type="date"
                      disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                    />
                    <TextField
                      name="time"
                      sx={{ flex: 0.4 }}
                      type="time"
                      disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                    <TextField sx={{ flex: 0.8 }} name="patient_name" placeholder="Patient Name" disabled />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Transfer Department</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="transfer_department"
                      placeholder="Transfer Department"
                      disabled
                      menus={departmentDropdown.map((data) => ({ ...data, name: data.department }))}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Transfer Unit</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="transfer_unit"
                      placeholder="Transfer Unit"
                      disabled
                      menus={departmentUnitDropdown.map((data) => ({ ...data, name: data.name }))}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>
                      Transfer Nursing Station
                    </Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="transfer_nursing_station"
                      placeholder="Transfer Nursing Station"
                      disabled
                      menus={nursingStationDropdown}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Transfer Ward</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="transfer_ward"
                      placeholder="Transfer Ward"
                      disabled={!['new', 'edit'].includes(currentAction)}
                      menus={wardDropdown}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Transfer Room</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="transfer_room"
                      placeholder="Transfer Room"
                      disabled={!['new', 'edit'].includes(currentAction)}
                      menus={roomDropdown
                        .filter(
                          (data) =>
                            data.nurse_station === watch('transfer_nursing_station') &&
                            data.ward === watch('transfer_ward') &&
                            data.department_unit === watch('transfer_unit')
                        )
                        .map((data) => ({ ...data, name: data.room_no }))}
                      onChange={() => {
                        setValue('transfer_bed_no', '');
                      }}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Transfer Bed No.</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="transfer_bed_no"
                      placeholder="Transfer Bed No"
                      disabled={!['new', 'edit'].includes(currentAction)}
                      menus={roomDropdown
                        .filter((data) => data._id === watch('transfer_room'))[0]
                        ?.beds?.filter((bed) => bed.occupy_status === 'F')
                        ?.map((bed) => ({ _id: bed.bed_no, name: bed.bed_no }))}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                    <TextField
                      sx={{ flex: 0.8 }}
                      name="remarks"
                      placeholder="remarks"
                      disabled={!['new', 'edit'].includes(currentAction)}
                    />
                  </Stack>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '20rem',
                    boxShadow: '0px 2px 4px #0099ff'
                  }}
                >
                  <Table
                    containerSX={{ flex: 1 }}
                    data={roomTransferDataObj.data?.filter((item) => item.ipd_no === selectedRecord?.ipd_no) || []}
                    columns={TRANSFER_HISTORY_HEADER}
                    size="small"
                  />
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Room Transfer Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' 
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' 
              }
            }}
            label="Search Patient By Name UHID or IPD No."
            variant="outlined"
            value={roomInput}
            onChange={handleRoomChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={roomTransferDataObj?.data || []}
          loading={roomTransferDataObj.loading}
          onRowClick={(row) => {
            const {
              room,
              department,
              ward,
              nur_station,
              unit,
              transfer_ward,
              transfer_department,
              transfer_room,
              transfer_unit,
              ...otherDetails
            } = row;
            setSelectedRecord({
              room: room?._id,
              unit: room?.department_unit,
              department: department?._id,
              ward: room?.ward,
              nur_station: room?.nurse_station,
              transfer_ward: transfer_ward?._id,
              transfer_department: transfer_department?._id,
              transfer_unit: transfer_unit?._id,
              transfer_room: row?.transfer_room?._id,
              transfer_nursing_station: transfer_room?.nurse_station,
              ...otherDetails
            });
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
